/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const Maximize: BridgeCommands.Command<
    {},
    undefined
    > = {
    legacyCommand: 'QUERY_WIN_MAXIMIZE',
    system: 'CrimsonNative',
    module: 'WindowControl',
    method: 'Maximize',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const Minimize: BridgeCommands.Command<
    {},
    undefined
    > = {
    legacyCommand: 'QUERY_WIN_MINIMIZE',
    system: 'CrimsonNative',
    module: 'WindowControl',
    method: 'Minimize',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const Restore: BridgeCommands.Command<
    {},
    undefined
    > = {
    legacyCommand: 'QUERY_WIN_RESTORE',
    system: 'CrimsonNative',
    module: 'WindowControl',
    method: 'Restore',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RestoreFromFullScreen: BridgeCommands.Command<
    {},
    undefined
    > = {
    legacyCommand: 'QUERY_WIN_RESTORE_FROM_FULLSCREEN',
    system: 'CrimsonNative',
    module: 'WindowControl',
    method: 'RestoreFromFullScreen',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const Resize: BridgeCommands.Command<
    Types.Common.Windowcontrol.WindowRectangle,
    any
    > = {
    legacyCommand: 'QUERY_WIN_RECT',
    system: 'CrimsonNative',
    module: 'WindowControl',
    method: 'Resize',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const Close: BridgeCommands.Command<
    {},
    undefined
    > = {
    legacyCommand: 'QUERY_WIN_CLOSE',
    system: 'CrimsonNative',
    module: 'WindowControl',
    method: 'Close',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const Focus: BridgeCommands.Command<
    Types.Common.Windowcontrol.FocusParameters,
    undefined
    > = {
    legacyCommand: 'QUERY_WIN_FOCUS',
    system: 'CrimsonNative',
    module: 'WindowControl',
    method: 'Focus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RequestUserAttention: BridgeCommands.Command<
    {},
    undefined
    > = {
    legacyCommand: 'QUERY_REQUEST_USER_ATTENTION',
    system: 'CrimsonNative',
    module: 'WindowControl',
    method: 'RequestUserAttention',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const EnableCloseButton: BridgeCommands.Command<
    Types.Common.Windowcontrol.EnableCloseButtonParameters,
    string
    > = {
    legacyCommand: 'QUERY_WIN_ALLOW_CLOSE',
    system: 'CrimsonNative',
    module: 'WindowControl',
    method: 'EnableCloseButton',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SynthesizeClickEvent: BridgeCommands.Command<
    Types.Common.Windowcontrol.SynthesizeClickEventParameters,
    any
    > = {
    legacyCommand: 'QUERY_SYNTHESIZE_CLICK_EVENT',
    system: 'CrimsonNative',
    module: 'WindowControl',
    method: 'SynthesizeClickEvent',
    persistent: false
};

export const Windowcontrol = {
Maximize,
Minimize,
Restore,
RestoreFromFullScreen,
Resize,
Close,
Focus,
RequestUserAttention,
EnableCloseButton,
SynthesizeClickEvent
};
